import styled from 'styled-components';

export const MyCompanyAnalyticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
`;
